/**
 * Da dove viene la cadenza di un obbligo, sotto la cadenza stessa.
 *
 * Si mostra sempre: e' la differenza fra un termine e un'ipotesi di termine, e
 * nessuno dei 121 obblighi ha una cadenza propria a catalogo. Il testo sta in
 * `lib/scadenze`, dove lo leggono anche le modali.
 */

import type { IdNodo } from "../api/types";
import { testoProvenienzaCadenza } from "../lib/scadenze";
import type { FonteCadenza } from "../lib/scadenze";

export function ProvenienzaCadenza({
  fonte,
  idNodoFonte,
}: {
  fonte: FonteCadenza;
  /** Nodo da cui la cadenza e' ereditata, quando `fonte` e' `sezione`. */
  idNodoFonte?: IdNodo;
}) {
  return <div className="campo__aiuto">{testoProvenienzaCadenza(fonte, idNodoFonte)}</div>;
}
